<template>
    <div>
        <head-banner title="קניות" />
        <div class="b_shop">
            <div class="container">
                <div class="shop_wrapper">
                    <div class="shop_list flex">
                        <div
                            v-for="shop in shops"
                            :key="shop.id"
                            class="shop_item"
                        >
                            <nuxt-link
                                class="shop_block text_center"
                                :to="`/shops/${shop.slug}`"
                            >
                                <div class="block_image">
                                    <div class="image_wrapper">
                                        <picture
                                            v-full-image-path="
                                                shop.featuredImage
                                            "
                                        />
                                    </div>
                                    <div class="block_title second_font">
                                        {{ shop.name }}
                                    </div>
                                </div>
                            </nuxt-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { StatusCodes } from 'http-status-codes';
import HeadBanner from '@/components/elements/HeadBanner';

export default {
    components: { HeadBanner },

    async asyncData({ store: { dispatch }, error }) {
        try {
            const shops = await dispatch('shops/index');

            return { shops };
        } catch (err) {
            if (
                err.response &&
                err.response.status !== StatusCodes.INTERNAL_SERVER_ERROR
            ) {
                return error({ statusCode: err.response.status });
            }

            console.error(err);

            return error({ statusCode: StatusCodes.INTERNAL_SERVER_ERROR });
        }
    },

    computed: {
        ...mapGetters({
            selectedCampus: 'campuses/selectedCampus'
        })
    },

    watch: {
        selectedCampus() {
            this.fetchShops();
        }
    },

    methods: {
        ...mapActions({
            getShops: 'shops/index'
        }),

        async fetchShops() {
            try {
                this.shops = await this.getShops();
            } catch (error) {
                console.error(error);

                this.$toasted.global.error();
            }
        }
    }
};
</script>
